var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about",attrs:{"id":"about","name":"about"}},[_vm._m(0),_c('div',{staticClass:"about-content"},[_c('MyMarkdown')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-header"},[_c('div',{staticClass:"about-title"},[_c('i',{staticClass:"el-icon-tickets",staticStyle:{"color":"#ff6700"}}),_vm._v(" 关于我们 ")])])
}]

export { render, staticRenderFns }